import axios from 'axios';
import { tokenStorage } from '@utils/tokenStorage';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API = axios.create({
  baseURL: API_BASE_URL,
});

/**
 * Endpoints that should NOT trigger session-expired redirects.
 * These are public or auth-related endpoints that can be called without an active session.
 */
const PUBLIC_ENDPOINTS = [
  '/v1/auth/sign-in',
  '/v1/auth/captcha',
  '/v1/auth/refresh',
  '/v1/users/recover-password',
];

API.interceptors.request.use((config) => {
  const token = tokenStorage.getAccessToken();
  if (!token) return config;

  config.headers = config.headers ?? {};
  (config.headers as any).Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url ?? '';

    const isPublic = PUBLIC_ENDPOINTS.some((p) => url.includes(p));

    // The backend may return 403 for an invalid/expired session on /users/me (policy-specific).
    // We treat it as "session expired" to provide a consistent UX.
    const isMeEndpoint = url.includes('/users/me'); // covers both "/v1/users/me" and "/api/v1/users/me"

    // Avoid redirect loops (e.g., if we are already on the login page).
    const isOnLoginPage = window.location.pathname.startsWith('/login');

    if (!isPublic && !isOnLoginPage && isMeEndpoint && (status === 401 || status === 403)) {
      tokenStorage.clearAll();

      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.replace(`/login?reason=session_expired&returnTo=${returnTo}`);
    }

    return Promise.reject(error);
  }
);

export default API;
